import {
  Component, Inject, OnInit,
} from '@angular/core';
import { TranslationService } from '../../common/translation.service';

/**
 * Component for handling email verification functionality within the account section.
 * Displays appropriate messages based on the verification result and user authentication status.
 * Provides navigation actions for logged-in and anonymous users.
 */
@Component({
  selector: 'bulb-account-verify-email',
  templateUrl: './account-verify-email.component.html',
  styleUrls: ['./account-verify-email.component.scss'],
  standalone: false,
})
export class AccountVerifyEmailComponent implements OnInit {

  success = false;

  failureCode = 'account_verify_email_token_invalid';

  title = '';

  isAuthenticated = false;

  loggedInMessage = '';

  anonymousMessage = '';

  /**
   * Creates a new instance of the class with required dependencies.
   * @param auth - The authentication service injected via 'BulbAuthService' token
   * @param state - The state service injected via '$state' token
   * @param translationService - The service used for handling translations
   */
  constructor(
    @Inject('BulbAuthService') private auth: any,
    @Inject('$state') private state: any,
    private translationService: TranslationService,
  ) {}

  /**
   * Initializes the component and performs initial setup.
   *
   * @return {void}
   */
  ngOnInit(): void {
    const verification = (window as any).bulbRootModel?.verifyEmail;
    if (verification) {
      this.success = verification.success;
      this.failureCode = verification.failureCode;
    }
    this.title = this.translationService.translateInstant('account_verify_email_title');
    this.isAuthenticated = this.auth.currentUser.isAuthenticated();

    const mySettings = this.translationService.translateInstant('account_settings_title');
    this.translationService.translateCustomKeys(
      'account_verify_email_action_logged_in',
      { link: `<a class="action-settings">${mySettings}</a>` },
    ).then((result) => {
      this.loggedInMessage = result;
    });

    const signIn = this.translationService.translateInstant('sign_in');
    this.translationService.translateCustomKeys(
      'account_verify_email_action_anonymous',
      { link: `<a class="action-sign-in">${signIn}</a>` },
    ).then((result) => {
      this.anonymousMessage = result;
    });
  }

  /**
   * Handles the follow action for links with specific classes.
   *
   * @param event - The mouse event triggered by clicking on a link
   */
  followAction(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const link = target.closest('a');

    if (!link) return;

    event.preventDefault();

    if (link.classList.contains('action-settings')) {
      this.state.go('account.settings');
    } else if (link.classList.contains('action-sign-in')) {
      this.state.go('signIn', { targetUrl: '/b/account/settings' });
    }
  }

  /**
   * Navigates to the user's profile page if they are authenticated.
   * If the user is not authenticated, redirects them to the home page.
   *
   * @return {void}
   */
  goToProfile(): void {
    if (!this.auth.currentUser.isAuthenticated()) window.location.href = '/';
    else this.state.go('author', { username: this.auth.currentUser.username });
  }
}
